import React from 'react';
import { ProductCategoryTiles as ProductCategoryTilesComponent } from '@raisin/components-lib';
import { ProductCategoryTilesProps } from '../../types';
import { getUpdatedExternalLink } from '../../utils/helpers';

export const ProductCategoryTiles: React.FC<ProductCategoryTilesProps> = ({ tiles, locale }) => {
  const updatedTiles = tiles.map((tile) => ({
    ...tile,
    cta_target: getUpdatedExternalLink(tile.cta_target, locale) as string,
  }));

  return <ProductCategoryTilesComponent tiles={updatedTiles} />;
};
